import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi, tokenStore } from "../lib/ledgerApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking, null = anon, obj = logged in
  const [business, setBusiness] = useState(null);

  const refreshMe = async () => {
    if (!tokenStore.access) {
      setUser(null);
      setBusiness(null);
      return;
    }
    try {
      const data = await authApi.me();
      setUser(data.user);
      setBusiness(data.business || null);
    } catch {
      tokenStore.clear();
      setUser(null);
      setBusiness(null);
    }
  };

  useEffect(() => {
    refreshMe();
  }, []);

  const setSession = (tokenResponse) => {
    tokenStore.set(tokenResponse.access_token, tokenResponse.refresh_token);
    setUser(tokenResponse.user);
    setBusiness(tokenResponse.business || null);
  };

  const logout = async () => {
    try {
      await authApi.logout();
    } catch {}
    tokenStore.clear();
    setUser(null);
    setBusiness(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, business, setSession, logout, refreshMe }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
